import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "explanationMessage", "validationMessage"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import * as React from 'react';
import { form } from '../assets/styles/utility';
import { jsx as ___EmotionJSX } from "@emotion/react";
const FormFooter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    explanationMessage,
    validationMessage
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme();
  return explanationMessage || validationMessage ? ___EmotionJSX("div", _extends({
    ref: ref,
    css: [_objectSpread(_objectSpread({}, theme.text.xsmall), {}, {
      display: 'grid',
      gridAutoColumns: '1fr',
      gridAutoFlow: 'column',
      gap: theme.space.small,
      marginTop: theme.space.xsmall,
      paddingLeft: form.variables(theme).controlOffset,
      paddingRight: form.variables(theme).controlOffset
    }), process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"],
    className: clsx('CK__FormFooter', className)
  }, rest), explanationMessage && ___EmotionJSX("div", {
    css: [{
      color: theme.fontColor.base
    }, theme.settings.contrast.enable && {
      '.u-contrast &': {
        color: theme.contrast.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"]
  }, explanationMessage), validationMessage && ___EmotionJSX("div", {
    css: [{
      color: theme.color.danger.base,
      textAlign: 'right'
    }, theme.settings.contrast.enable && {
      '.u-contrast &': {
        color: theme.contrast.base
      }
    }, process.env.NODE_ENV === "production" ? "" : ";label:FormFooter;"]
  }, validationMessage)) : null;
});
export default FormFooter;